
<form [formGroup]="payHistory">
    <div class="card-body pb-0 spacing" #contentToConvert>
        <div class="receipt ">
            <div class="row ">
                <!-- <div class="col-sm-2 mb-3">
                    <img src="../../assets/img/logo-light.png" class="header-brand-img desktop-logo" alt="logo">
                </div>
                <div class="col-sm-10">
                    <h6 class="mra">{{InstuName}}</h6>
                    <h6 class="mra1">Payment Receipt</h6>
                </div> -->

                   <div class="col-sm-3">
                        <img src="../../assets/img/logo-light.png" class="header-brand-img reciptLogo desktop-logo" alt="logo">
                    </div>
                         <div class="col-sm-9">
                        <h3 class="mra23">{{InstuName}}</h3>
                        <h6 class="mra11">(A State University of the Govt. of Assam)</h6>
                        <h6 class="mra1">{{data.FeeType === 'AF' ? 'Registration' : data.FeeType === 'EF' ? 'Exam' : ''}} Payment Receipt</h6>
                        <h6 class="addc">Address: 2nd Floor, Gauhati Medical College Building, Narkashur Hilltop, Bhangagarh, Guwahati-781032,Assam</h6>
                        <h6 class="addc">Tel:6026177313 | Email:ssuhs_assam@yahoo.in | Web: http://www.ssuhs.in/    GST No. : 18SHLS03712C1DR</h6>
                    </div>
            </div>
            <div class="row">
                <div class="receipt-details">
                    <div class="row">
                        <div class="col-sm-6">
                            <p><strong>Receipt Number: </strong> {{reciptNumber}}</p>
                        </div>
                        <div class="col-sm-6">
                            <p><strong>Receipt Date: </strong> {{currentDate | date: 'dd/MM/yyyy'}}</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <p><strong>College: </strong> {{clgName}} <span id="college"></span></p>
                        </div>
                        <div class="col-sm-6">
                            <p><strong>Course: </strong> {{CoName}} <span id="program"></span></p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <p><strong>Rg No.:</strong>{{formattedPrn}}</p>
                        </div>
                       
                        <div class="col-sm-6">
                            <p><strong>Student Name: </strong>   {{ FullName ? FullName : (FirstName + ' ' + (MiddleName || '') + ' ' + (LastName || '')) }}</p>
                        </div>
                    </div>
                        <div class="row">
                        <div class="col-sm-6">
                            <p><strong>Father Name: </strong> {{FatherName}}</p>
                        </div>
                        <div class="col-sm-6">
                            <p><strong>Mother Name:</strong> {{MotherName}} </p>
                        </div>
                    </div>
                        <div class="row">
                        <div class="col-sm-6">
                            <p><strong>Mobile No.:</strong> {{mobileNo}}</p>
                        </div>
                        <div *ngIf="DateOfBirth" class="col-sm-6">
                            <p><strong>DOB:</strong>{{stuDOB | date: 'dd/MM/yyyy'}} </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mt-2">
                <table class="styled-table" style="width:100%; ">
                        <thead>
                            <tr>
                                <th width="40%" class="f600 text-center">Fee Head</th>
                                <th width="20%" class="f600 text-center">Fee Paid</th>
                                <th width="20%" class="f600 text-center">Transaction Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of payHistoryData; let i = index">
                                <td class="text-center">{{item.Head}}</td>
                                <td class="text-center" *ngIf="Currency == 'INR' ">
                                    <span class="currency-symbol Textmrg1">&#8377;{{item.FeeAmt}}</span>
                                </td>
                                <td class="text-center" *ngIf="Currency == 'USD' ">
                                    <span class="currency-symbol Textmrg1">$ {{item.FeeAmt}}</span>
                                </td>
                                <td class="text-center">{{item.FeePaymentDate | date: 'dd/MM/yyyy'}}</td>

                            </tr>
                        </tbody>

                    </table>
            </div>

            <div class="row">
                <div class="receipt-footer">
                    <div class="row mt-1">
                        
                        <div class="col-sm-6" *ngIf="Currency == 'INR' "> 
                            <b>Total Paid Amount :</b>
                            <span class="currency-symbol Textmrg1">&#8377;{{TotalPaidAmount}}</span></div>
                    
                            <div class="col-sm-6" *ngIf="Currency == 'USD' "> 
                                <b>Total Paid Amount :</b>
                                <span class="currency-symbol Textmrg1">$ {{TotalPaidAmount}}</span></div>
                                <div class="col-sm-6" *ngIf="Currency == 'INR' ">
                                    <b>In Words: </b>
                                    <span class="currency-symbol linkk Textmrg1">Rupees {{TotalPaidAmountInWords}} Only</span>
                                </div>
                                
                                <div class="col-sm-6" *ngIf="Currency == 'USD' ">
                                    <b>In Words: </b>
                                    <span class="currency-symbol linkk Textmrg1">Dollars {{TotalPaidAmountInWords}} Only</span>
                                </div>
                                
                                </div>
                    <!-- <div  class="row">
                       
                    </div> -->
                  
                     <div class="row mt-2">
                        <div class="col-sm-6">
                            <b>Transaction Ref. No.:</b>
                            <span class=" Textmrg1"> {{TransactionNo}}</span>
                        </div>
                        <div class="col-sm-6">
                            <b>Payment Mode:</b>
                            <span class=" Textmrg1"> {{payModeee}}</span>
                        </div>
                    </div>
                    <!-- <div class="row">
                        <div class="col-sm-6">
                            <p><strong>Date:</strong> {{currentDate | date: 'dd/MM/yyyy'}}</p>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
        <div class="row col-sm-12 mb-2 mt-2">
            <div class="col-sm-2 divName offset-8">
                <button type="button" class="btn no-print fr sz btn-primary btn-icon-text floatright mt-1 fr" (click)="close()">
                    <span style="display: contents; align-items: center;">
                        <!-- <img width="20vh" src="../../assets/img/letter-x.gif" style="margin-right: 5px;"> -->
                        Close
                    </span>
                </button>
            </div>
            <div class="col-sm-2 divName" >
                <button type="button" class="btn no-print fr sz btn-primary btn-icon-text floatright mt-1 fr"
                    (click)="downloadAsPDF()">
                    <span  style="display: contents; align-items: center;">
                        Download
                        <!-- <img width="20vh" src="../../assets/img/download img.png" style="margin-right: 5px;"> -->
                    </span>
                </button>
            </div>
        </div>
    </div>
</form>